// extracted by mini-css-extract-plugin
module.exports = {"H1":"h1_H1__2RM9j","IconLeft":"h1_IconLeft__1e93C","IconRight":"h1_IconRight__1apXv"};